import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {

    @Input()
    public onlyIntegers = false;

    @Input()
    public only2Decimals = true;

    regexStr = '^[0-9]*$';
    constructor(private el: ElementRef) { }

    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent) {
      let inputs = [46, 8, 9, 27, 13, 110];
      if (!this.onlyIntegers) { inputs.push(190) }

      const decimales = this.el.nativeElement.value.split('.');
      
      if (this.only2Decimals && decimales.length > 1) {
        if (decimales[1].length > 1) {          
          e.preventDefault();
        } 
      }
      
      if (inputs.indexOf(e.keyCode) !== -1 ||
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true) ||
        (e.keyCode === 65 && e.metaKey === true) ||
        (e.keyCode === 67 && e.metaKey === true) ||
        (e.keyCode === 86 && e.metaKey === true) ||
        (e.keyCode === 88 && e.metaKey === true) ||
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        return;
      }

      if (
        (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault();
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/directives/only-number.directive.ts